// ── Hero slideshow ──
function initHeroSlideshow() {
  const slides = document.querySelectorAll('.hero-slide');
  const dots   = document.querySelectorAll('.slide-dot');
  if (!slides.length) return;
  let idx = 0, timer;

  function goTo(i) {
    slides[idx].classList.remove('active');
    dots[idx] && dots[idx].classList.remove('active');
    idx = i;
    slides[idx].classList.add('active');
    dots[idx] && dots[idx].classList.add('active');
  }
  function next() { goTo((idx + 1) % slides.length); }
  function start() { timer = setInterval(next, 3800); }
  function stop()  { clearInterval(timer); }

  dots.forEach((d, i) => d.addEventListener('click', () => { stop(); goTo(i); start(); }));
  window.heroGoTo = (i) => { stop(); goTo(i); start(); };
  start();
}

// ── Sticky nav ──
function initNav() {
  const nav = document.querySelector('.site-nav');
  if (!nav) return;
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 8);
  }, { passive: true });
}

// ── Mobile drawer ──
function initDrawer() {
  const drawer   = document.getElementById('mobile-drawer');
  const backdrop = document.getElementById('drawer-backdrop');
  const toggle   = document.getElementById('nav-toggle');
  const closeBtn = document.getElementById('drawer-close');
  if (!drawer || !backdrop || !toggle) return;

  function open() {
    drawer.classList.add('open');
    backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
  }

  function close() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  }

  toggle.addEventListener('click', open);
  backdrop.addEventListener('click', close);
  closeBtn && closeBtn.addEventListener('click', close);
  drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', close));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  // Resizing past the breakpoint hides the drawer but would leave scroll locked
  window.addEventListener('resize', () => {
    if (window.innerWidth > 780 && drawer.classList.contains('open')) close();
  });
}

// ── Scroll reveal ──
function revealUpTo(target) {
  document.querySelectorAll('.reveal').forEach(el => {
    if (el === target || target.contains(el) || (el.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      el.classList.add('in');
    }
  });
}

function initReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.12 });
  els.forEach(el => obs.observe(el));

  // Landed directly on a section via hash link (e.g. nav "Shop" from another
  // page) — reveal everything up to it immediately so it isn't hidden behind
  // the scroll-triggered fade-in and doesn't look like a blank page.
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) revealUpTo(target);
  }
}

// ── Same-page section nav (Shop/Collections/About/Contact) ──
// These links point at #section anchors on the homepage. Left as plain
// hrefs, clicking them from the homepage still forces a full page reload
// (browsers don't treat an absolute same-page URL as a same-document jump),
// which flashes the reveal-hidden (opacity:0) sections before their fade-in
// re-triggers. Intercept same-page clicks and smooth-scroll instead; links
// to sections on a *different* page still navigate normally.
function initSectionNav() {
  document.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      let url;
      try { url = new URL(link.getAttribute('href'), window.location.href); } catch { return; }
      if (!url.hash || url.pathname !== window.location.pathname) return;
      const target = document.querySelector(url.hash);
      if (!target) return;
      e.preventDefault();
      revealUpTo(target);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', url.hash);
    });
  });
}

// ── Newsletter ──
function initNewsletter() {
  const form = document.querySelector('.nl-form');
  if (!form) return;
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn  = form.querySelector('.nl-btn');
    const data = new FormData(form);
    btn.disabled = true;
    btn.textContent = 'Joining…';
    try {
      const res = await fetch(form.action, { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
      if (res.ok || res.redirected) {
        btn.textContent = "You're in ☺";
        btn.style.background = '#2C5A3E';
        form.querySelector('input[type="email"]').value = '';
      } else {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    } catch {
      btn.textContent = 'Try again';
      btn.disabled = false;
    }
  });
}

// ── Product page ──
function initProductPage() {
  if (!document.querySelector('.product-page')) return;

  // Color → { front, back } image map (populated by the Liquid inline script
  // on main-product.liquid). Swapping color keeps the current view and vice versa.
  const colorImages = window.SmileColorImages || {};
  const productTitle = document.querySelector('.product-title')?.textContent.trim() || '';
  let currentColor = document.getElementById('color-label')?.textContent.trim() || '';
  let currentView  = 'front';

  function renderImage(instant) {
    const mainImg = document.getElementById('main-img');
    const set = colorImages[currentColor];
    if (!mainImg || !set) return;
    const src = set[currentView] || set.front;
    if (!src) return;
    const alt = `${productTitle} — ${currentColor}, ${currentView}`;

    if (instant) {
      mainImg.src = src;
      mainImg.alt = alt;
      return;
    }
    mainImg.classList.add('fade');
    setTimeout(() => {
      mainImg.src = src;
      mainImg.alt = alt;
      mainImg.classList.remove('fade');
    }, 220);
  }

  // Warm the other side so toggling never flashes an empty frame
  function preloadOtherView() {
    const set = colorImages[currentColor];
    if (!set) return;
    const other = currentView === 'front' ? set.back : set.front;
    if (other) new Image().src = other;
  }

  // A color with a single photo has no back shot — hide the toggle for it
  function updateToggle() {
    const set = colorImages[currentColor] || {};
    const toggle = document.getElementById('view-toggle');
    if (!set.back && currentView === 'back') currentView = 'front';
    if (toggle) toggle.hidden = !set.back;
    document.querySelectorAll('.view-btn').forEach(b => {
      b.classList.toggle('active', b.dataset.view === currentView);
    });
  }

  // Keep ?color= and ?view= shareable without dropping Shopify's ?variant=
  function syncUrl() {
    const params = new URLSearchParams(window.location.search);
    params.set('color', currentColor);
    params.set('view', currentView);
    history.replaceState(null, '', `${window.location.pathname}?${params}`);
  }

  window.selectView = (view, instant) => {
    if (view !== 'front' && view !== 'back') return;
    currentView = view;
    updateToggle();
    renderImage(instant);
    preloadOtherView();
    if (!instant) syncUrl();
  };

  window.selectColor = (el, instant) => {
    currentColor = el.dataset.color;
    document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
    el.classList.add('active');
    const lbl = document.getElementById('color-label');
    if (lbl) lbl.textContent = currentColor;

    updateToggle();
    renderImage(instant);
    preloadOtherView();
    if (!instant) syncUrl();

    // Sync Shopify variant selector
    syncVariant();
  };

  // ── Swipe the image to flip front ↔ back ──
  (function () {
    const wrap = document.getElementById('main-image-wrap');
    if (!wrap) return;
    let startX = 0, startY = 0;

    wrap.addEventListener('touchstart', e => {
      startX = e.changedTouches[0].clientX;
      startY = e.changedTouches[0].clientY;
    }, { passive: true });

    wrap.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      // Horizontal intent only, so vertical scrolling still works
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        window.selectView(currentView === 'front' ? 'back' : 'front');
      }
    }, { passive: true });
  })();

  updateToggle();
  preloadOtherView();

  window.selectSize = (el) => {
    document.querySelectorAll('.size-btn:not(.soldout)').forEach(b => b.classList.remove('active'));
    el.classList.add('active');
    const lbl = document.getElementById('size-label');
    if (lbl) lbl.textContent = el.textContent;
    syncVariant();
  };

  function syncVariant() {
    const color = document.getElementById('color-label')?.textContent || '';
    const size  = document.getElementById('size-label')?.textContent || '';
    const variantSelect = document.getElementById('variant-id');
    if (!variantSelect) return;
    const opts = variantSelect.options;
    for (let o of opts) {
      if (o.dataset.color === color && o.dataset.size === size) {
        variantSelect.value = o.value;
        break;
      }
    }
  }

  window.changeQty = (delta) => {
    const input = document.getElementById('qty');
    if (!input) return;
    const val = parseInt(input.value) + delta;
    if (val >= 1 && val <= 10) input.value = val;
  };

  window.toggleWishlist = () => {
    const btn  = document.getElementById('wishlist-btn');
    const icon = document.getElementById('wish-icon');
    const text = document.getElementById('wish-text');
    if (!btn) return;
    const saved = btn.classList.toggle('saved');
    if (text) text.textContent = saved ? 'Saved to Wishlist' : 'Add to Wishlist';
    if (icon) icon.setAttribute('fill', saved ? 'currentColor' : 'none');
  };

  window.toggleAccordion = (trigger) => {
    const item   = trigger.closest('.accordion-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  };

  // Pre-select color and view from URL params — validate to safe characters only
  const params = new URLSearchParams(window.location.search);
  const c = params.get('color');
  if (c && /^[\w\s-]{1,64}$/.test(c)) {
    const swatch = document.querySelector(`.color-swatch[data-color="${CSS.escape(c)}"]`);
    if (swatch) window.selectColor(swatch, true);
  }
  const v = params.get('view');
  if (v === 'front' || v === 'back') window.selectView(v, true);
}

// ── Cart AJAX ──
function initCart() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = document.getElementById('add-cart-btn');
    const variantId = parseInt(document.getElementById('variant-id')?.value, 10);
    const qty = parseInt(document.getElementById('qty')?.value || '1', 10);

    if (!variantId || isNaN(variantId)) { alert('Please select a size.'); return; }

    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });

      if (!res.ok) throw new Error();

      const cart = await fetch('/cart.js').then(r => r.json());
      const badge = document.querySelector('.cart-badge');
      if (badge) badge.textContent = cart.item_count;

      btn.textContent = 'Added! ✓';
      btn.style.background = '#2C5A3E';

      const toast = document.getElementById('toast');
      if (toast) { toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 2800); }

      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.style.background = '';
        btn.disabled = false;
      }, 2500);

    } catch {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
      alert('Something went wrong. Please try again.');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initDrawer();
  initHeroSlideshow();
  initReveal();
  initSectionNav();
  initNewsletter();
  initProductPage();
  initCart();
});
